






















import { Component, Vue } from 'vue-property-decorator';
import AudioBar from '@/components/AudioBar/index.vue';
import HeaderBar from '@/components/HeaderBar/index.vue';
import BottomFooter from '@/components/BottomFooter/index.vue';
import BackTop from '@/components/BackTop/index.vue';
import { ABAction } from '@/stores/audioBar';
import throttle from 'lodash/throttle';

@Component({
  components: {
    AudioBar,
    HeaderBar,
    BottomFooter,
    BackTop,
  },
})
export default class App extends Vue {
  public showBackTop: boolean = false;

  public throttleScroll: any;

  constructor() {
    super();

    this.throttleScroll = throttle(this.handleScroll, 100);
  }

  public handleClickCloseAllModal() {
    this.$store.dispatch(ABAction('closeAllModal'));
  }

  public handleScroll(e: any) {
    if (e.target.scrollTop >= 300) {
      this.showBackTop = true;
    } else {
      this.showBackTop = false;
    }
  }
}
